import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IWarehouseTransferDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWarehouseTransferDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class WarehouseTransferDetail_ScreenBase extends React.PureComponent<
  IWarehouseTransferDetail_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  warehousetransferdetail_576320_value_kuikaTableRef: React.RefObject<any>;
  warehousetransferdetail_196727_value_kuikaPaginationRef: React.RefObject<any>;
  warehousetransferdetail_633835_value_kuikaTableRef: React.RefObject<any>;
  warehousetransferdetail_355611_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "f2dda443-9398-43ec-a079-07c2bec1b1c9",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 245868, PropertyName: "value", Value: "Depolar Arası Transfer" },
        { Id: 943807, PropertyName: "tab", Value: "Satırlar" },
        { Id: 553760, PropertyName: "value", Value: "Çıkar/Ekle" },
        { Id: 821407, PropertyName: "value", Value: "Çıkar/Ekle" },
        { Id: 980938, PropertyName: "placeholder", Value: "15" },
        { Id: 656145, PropertyName: "placeholder", Value: "Barkod Giriniz..." },
        { Id: 263027, PropertyName: "value", Value: "Barkod" },
        { Id: 251937, PropertyName: "value", Value: "label" },
        { Id: 576803, PropertyName: "value", Value: "Barkod Bulunamadı" },
        {
          Id: 721759,
          PropertyName: "value",
          Value: "Henüz sayılmamış üründen çıkarma yapılamaz",
        },
        { Id: 402812, PropertyName: "value", Value: "Eklendi" },
        { Id: 530942, PropertyName: "value", Value: "Çıkartıldı" },
        { Id: 174934, PropertyName: "value", Value: "label" },
        { Id: 650156, PropertyName: "value", Value: "label" },
        { Id: 367813, PropertyName: "value", Value: "label" },
        { Id: 902974, PropertyName: "value", Value: "label" },
        { Id: 358223, PropertyName: "value", Value: "label" },
        { Id: 869192, PropertyName: "value", Value: "label" },
        { Id: 166599, PropertyName: "value", Value: "label" },
        { Id: 780854, PropertyName: "value", Value: "label" },
        { Id: 984815, PropertyName: "value", Value: "label" },
        { Id: 626780, PropertyName: "value", Value: "label" },
        { Id: 669539, PropertyName: "value", Value: "label" },
        { Id: 657165, PropertyName: "value", Value: "label" },
        { Id: 117271, PropertyName: "value", Value: "Ürün Ara" },
        { Id: 70262, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 384749, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 60849, PropertyName: "label", Value: "Ara" },
        { Id: 889049, PropertyName: "title", Value: "Title" },
        { Id: 314991, PropertyName: "value", Value: "label" },
        { Id: 201767, PropertyName: "value", Value: "label" },
        { Id: 489492, PropertyName: "value", Value: "label" },
        { Id: 589172, PropertyName: "value", Value: "label" },
        { Id: 791468, PropertyName: "value", Value: "label" },
        { Id: 835366, PropertyName: "value", Value: "label" },
        { Id: 594209, PropertyName: "tab", Value: "Sonuç" },
        { Id: 850099, PropertyName: "title", Value: "Title" },
        { Id: 877028, PropertyName: "value", Value: "label" },
        { Id: 955429, PropertyName: "value", Value: "label" },
        { Id: 158720, PropertyName: "value", Value: "Adet" },
        { Id: 938055, PropertyName: "value", Value: "label" },
        { Id: 531425, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.warehousetransferdetail_656145_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_550531_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_22731_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_576320_value_kuikaTableRef = React.createRef();
    this.warehousetransferdetail_196727_value_kuikaPaginationRef =
      React.createRef();
    this.warehousetransferdetail_633835_value_kuikaTableRef = React.createRef();
    this.warehousetransferdetail_355611_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "warehousetransferdetail",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferdetail",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferdetail",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      warehousetransferdetail_135272_value: false,
      warehousetransferdetail_980938_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
